import React, { Component } from 'react'
import {inject, observer} from "mobx-react";
import {Button, Col, Row} from 'reactstrap'
import Card from '../../comum/components/Card'
import FormSelectSimples from '../../comum/components/FormSelectSimples'
import InputFiltro from '../../comum/components/InputFiltro'

@inject("store")
@observer
export default class FiltrosBloqueioBl extends Component {
    
    constructor(props){
        super(props)
        this.controller = this.props.controller
        
        this.handleFiltrar = this.handleFiltrar.bind(this)
    }

    componentDidMount(){
        this.controller.listarOperacoes()
    }

    handleFiltrar = () => {
        //lembrar de enfiar as informações aqui
        this.controller.listarBls()
        this.controller.clickFiltrar = true
    }

    render() {
        return (
            <div className="filtro-card">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        <InputFiltro xs={12} sm={12} md={4} lg={4} xl={2}
                            titulo="BL"
                            onEnter={() => this.handleFiltrar()}
                            onChange={this.controller.onChangeFiltroBl}
                        />
                        <FormSelectSimples xs={12} sm={12} md={4} lg={4} xl={2}
                            titulo="Operação"
                            itens={this.controller.operacoes}
                            dado={this.controller.operacaoEscolida}
                            bloqueado={this.controller.operacoes.length === 0}
                            onChange={ (event) => this.controller.onChangeOperacao(event) }
                        />
                        <Col className={"px-0 mt-1 form-select-simples"} xs={6} sm={6} md={4} lg={4} xl={2}>
                            <div className="w-100">
                                <Button className="ml-2 btn-com-bordas-primary btn-filtrar" style={{marginTop: "19px"}} onClick={this.handleFiltrar}>Filtrar</Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/components/FiltrosBloqueioBl.js